import { createContext, useContext } from "react";
import { ApiResponse } from "../../api/types";
import { defined } from "../../utilities/typeHelper";
import {
  GetReportAuthorizationResponse,
  NameValidationResponse,
  ReportAuthorizationInfo,
  UpdateReportAuthorizationRequest,
  ValidateReportNameRequest,
} from "../api/biClient.types";

export interface BiApiClientBase {
  validateName: (request: ValidateReportNameRequest) => Promise<ApiResponse<NameValidationResponse>>;
  getReportSharing: (reportId: string) => Promise<ApiResponse<GetReportAuthorizationResponse>>;
  updateReportSharing: (
    reportId: string,
    request: UpdateReportAuthorizationRequest
  ) => Promise<ApiResponse<ReportAuthorizationInfo>>;
}

export const BiApiClientContext = createContext<BiApiClientBase | undefined>(undefined);

export const useBiApiClientProvider = <T extends BiApiClientBase = BiApiClientBase>(): T => {
  const client = useContext(BiApiClientContext) as T | undefined;
  return defined(client);
};
